import React from "react";
import { useNavigate } from "react-router-dom";
import Input from "./components/Input";

function Yhteystiedot() {
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    postalcode: "",
    postalcity: "",
    comment: "",
    error: "",
    forward: false,
  });

  React.useEffect(() => {
    document.title = "Yhteystiedot ja hinnasto - mitattu.fi";
    // Remove previous meta description if exists
    const oldMeta = document.querySelector('meta[name="description"]');
    if (oldMeta) document.head.removeChild(oldMeta);
    // Add new meta description
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = "Sisäilmamittauksen hinnasto ja yhteydenotto";
    document.head.appendChild(meta);
  }, []);
  
  React.useEffect(() => {
    if (state.forward) {
      navigate("/kiitos");
    }
  }, [state.forward, navigate]);

  const onChangeEvent = (evt) => {
    setState((prev) => ({
      ...prev,
      [evt.target.id]: evt.target.value,
    }));
  };

  const postForm = () => {
    try {
      fetch(
        "https://zk37skcbae.execute-api.eu-west-1.amazonaws.com/dev/email/send",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(state),
        }
      ).then((response) => {
        if (response.status === 200) {
          setState((prev) => ({ ...prev, forward: true }));
        } else {
          setState((prev) => ({
            ...prev,
            error:
              "Lähetys ei onnistunut. Laita ystävällisesti kysymys sähköpostilla.",
          }));
        }
      });
    } catch (err) {
      setState((prev) => ({
        ...prev,
        error:
          "Lähetys ei onnistunut. Laita ystävällisesti kysymys sähköpostilla.",
      }));
    }
  };

  return (
    <>
      <div className="contact-page">
        <div className="pricelist">
          <h1>Hinnasto</h1>
          <h2>Anturisto</h2>
          <h3>Lämpötila + kosteus</h3>
          <dl>
            <dt>Hinta</dt>
            <dd>70 €</dd>
          </dl>
          <h3>Hiilidioksidi (CO2) + lämpötila + kosteus</h3>
          <dl>
            <dt>Hinta</dt>
            <dd>165 €</dd>
          </dl>
          <h3>Paine-ero + lämpötila</h3>
          <dl>
            <dt>Hinta</dt>
            <dd>165 €</dd>
          </dl>
          <h3>VOC + lämpötila + kosteusanturi</h3>
          <dl>
            <dt>Hinta</dt>
            <dd>165 €</dd>
          </dl>
          <h3>PM2.5 + PM10 + lämpötila + kosteus</h3>
          <dl>
            <dt>Hinta</dt>
            <dd>165 €</dd>
          </dl>
          <h2>Vuokraus</h2>
          <dl>
            <dt>Hinta / anturi</dt>
            <dd>50 € / vko</dd>
          </dl>
          <h2>Toimitus</h2>
          <dl>
            <dt>Postitse</dt>
            <dd>30 €</dd>
          </dl>
          <h2>Verkkoliikennemaksu</h2>
          <dl>
            <dt>Anturien verkkoliikenne</dt>
            <dd>3,5&nbsp;€/kk/anturi</dd>
          </dl>
          <h2>Takuu</h2>
          <dl>
            <dt>Laitteiden takuu</dt>
            <dd>1 vuosi</dd>
            <dt>Laitteiden elinikä</dt>
            <dd>Noin&nbsp;5&nbsp;vuotta</dd>
          </dl>
        </div>
        <div className="contact-form">
          <h1>Ota yhteyttä</h1>
          <Input label="Nimi" id="name" onChange={onChangeEvent} />
          <Input
            label="Sähköposti"
            id="email"
            type="email"
            onChange={onChangeEvent}
          />
          <Input
            label="Puhelinnumero"
            id="phone"
            type="tel"
            onChange={onChangeEvent}
          />
          <Input
            label="Lähiosoite"
            id="address"
            onChange={onChangeEvent}
          />
          <Input
            label="Postinumero"
            id="postalcode"
            className="postal-code"
            onChange={onChangeEvent}
          />
          <Input
            label="Postitoimipaikka"
            id="postalcity"
            className="postal-city"
            onChange={onChangeEvent}
          />
          <label>
            <span className="full">Tarkempi kuvaus tavoitteistasi</span>
            <textarea
              id="comment"
              name="comment"
              onChange={onChangeEvent}
            ></textarea>
          </label>
          <input
            type="submit"
            onClick={postForm}
            className="button"
            value="Lähetä"
          />
          <p style={{ color: "red" }}>{state.error}</p>
        </div>
      </div>
    </>
  );
}

export default Yhteystiedot;
